module.exports = __webpack_public_path__ + "img/exam-result.f988acf5.webp";